const chatService = {
	newQuestion: async (prompt: string, token: string | null) => {
		try {
			const response = await fetch(`${process.env.REACT_APP_BASE_URL}/chat`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				body: JSON.stringify({ prompt }),
			});

			if (!response.ok) {
				throw new Error("Network response was not ok");
			}

			// Assuming the backend now returns a simple JSON with the text response and the audio URL
			const data = await response.json();

			// No need to manually parse multipart content, directly use the JSON data
			const { response: textResponse, audioUrl } = data;

			console.log(textResponse); // Log the text response
			console.log(audioUrl); // Log the audio URL

			// Return the text response and audio URL for use in the frontend
			return { textResponse, audioUrl };
		} catch (error) {
			console.error("Error fetching chat response:", error);
			throw error; // Rethrow or handle as needed
		}
	},
};

export default chatService;
